import React from "react";
import "./Hero.css";

interface HeroProps {
  onAppInstallClick: () => void;
}

const Hero: React.FC<HeroProps> = ({ onAppInstallClick }) => {
  return (
    <section id="home" className="hero-section">
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="hero-title-small">
              평범한 일상이 특별한 이야기로
            </span>
            기억의 서랍
            <br />
            <button
              className="app-install-btn"
              onClick={onAppInstallClick}
              // style={{ display: "inline-block" }}
              style={{ display: "none" }}
            >
              앱 설치하기
            </button>
          </h1>
        </div>
      </div>
      <div className="scroll-indicator">
        <div>아래로 스크롤 ↓</div>
      </div>
    </section>
  );
};

export default Hero;
